import { useEffect, useState } from 'react';

import { Spinner } from './ui/spinner';

const ProgressBar = ({ progress }: { progress: number }) => {
  let message = '';
  if (progress <= 32) {
    message = 'Fetching playerinfo...';
  } else if (progress <= 55) {
    message = 'Applying grenade-data...';
  } else if (progress <= 71) {
    message = 'Calculating economy...';
  } else {
    message = 'Pre-rendering graphics...';
  }

  return (
    <div className="flex w-80 flex-col items-center gap-2">
      <div className="h-3 w-full overflow-hidden rounded-full bg-gray-700">
        <div
          className="
            h-full
            animate-[background-position_1s_linear_infinite]
            bg-[repeating-linear-gradient(45deg,var(--color-blue-500),var(--color-blue-500)_10px,var(--color-blue-600)_10px,var(--color-blue-600)_20px)]
            bg-size-[20px_20px]
            transition-all duration-200 ease-out
          "
          style={{ width: `${Math.min(progress, 100)}%` }}
        />
      </div>
      <p className="text-sm text-white">{message}</p>
    </div>
  );
};

export const DemoViewerHydrateFallback = () => {
  // 1) Start at 15% (endowed progress)
  const [progress, setProgress] = useState(15);

  useEffect(() => {
    const totalDuration = 29000; // 20s from 15 → 99
    const startProgress = 15;
    const maxProgress = 99;
    const startTime = performance.now();

    // cubic ease-out: slow early, fast later
    const easeOutCubic = (t: number) => 1 - Math.pow(1 - t, 3);

    const intervalMs = 50; // update every 50ms
    const intervalId = setInterval(() => {
      const now = performance.now();
      const t = Math.min((now - startTime) / totalDuration, 1);
      const eased = easeOutCubic(t);
      const current = startProgress + (maxProgress - startProgress) * eased;
      setProgress(current);

      if (t >= 1) {
        clearInterval(intervalId);
      }
    }, intervalMs);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="absolute inset-0 z-50 flex flex-col items-center justify-center gap-6 bg-black bg-opacity-50">
      <Spinner
        className="
          h-12 w-12 animate-spin
          text-blue-500
          [animation-duration:0.5s]
        "
      />
      <ProgressBar progress={progress} />
    </div>
  );
};
